import { render, staticRenderFns } from "./politicsProjectManage.vue?vue&type=template&id=11fa72f8&scoped=true"
import script from "./politicsProjectManage.vue?vue&type=script&lang=js"
export * from "./politicsProjectManage.vue?vue&type=script&lang=js"
import style0 from "./politicsProjectManage.vue?vue&type=style&index=0&id=11fa72f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fa72f8",
  null
  
)

export default component.exports